<template>
  <div class="acmper">
    <!-- 顶部按钮 -->
    <div style="display:flex;justify-content: space-between;">
      <button
        class="buttons"
        style="background-color: #ee0a24;"
        @click="$router.back()"
      >返回</button>

      <button
        class="buttons"
        style="float:right;color:#000;background-color: #fff;border:1px solid #000;"
        @click="onTarget()"
      >选择目标小队</button>

    </div>
    <!-- /顶部按钮 -->

    <!-- 中队长显示 -->
    <div style="padding:20px 0 0;font-size:15px;font-weight:700">
      <span style="margin-right:10px;">{{info.name}}</span>
      <span>{{info.captain_name}}</span>
      <span style="margin-left:10px;color:#ee0a24">{{info.captain_mobile}}</span>
      <span>,</span>
      <span
        style="margin-left:10px;"
        v-show="info.member_ct"
      >总计 <span style="color:#ee0a24">{{info.member_ct}}人</span></span>
    </div>
    <!-- /中队长显示 -->

    <!-- 表 -->
    <div>
      <div
        v-for="(item,index) in List"
        :key="index"
      >
        <!-- 小队长显示 -->
        <div style="font-size:15px;font-weight:700;padding: 15px 0 8px">
          <span style="margin-right:10px;">{{item.name}}</span>
          <span>{{item.captain_name || '暂无队长'}}</span>
          <span style="margin-left:10px;color:#ee0a24">{{item.captain_mobile||'暂无手机号'}}</span>
          <span>,</span>
          <span style="margin-left:10px;">总计 <span style="color:#ee0a24">{{item.member_ct}}人</span></span>
        </div>
        <!-- /小队长显示 -->

        <van-row>
          <van-col
            span="2"
            class="text-center"
          >序号</van-col>
          <van-col
            span="4"
            class="text-center"
          >姓名</van-col>
          <van-col
            span="2"
            class="text-center"
          >性别</van-col>
          <van-col
            span="3"
            class="text-center"
          >房间</van-col>

          <van-col
            :span="6"
            class="text-center"
          >电话</van-col>
          <van-col
            :span="6"
            class="text-center"
          >渠道</van-col>
        </van-row>

        <!-- /表 -->

        <div style="margin-top:5px">
          <div
            v-for="(item2,index2) in item.members"
            :key="index2"
          >
            <van-row
              type="flex"
              style="margin-top:5px"
            >
              <van-col
                span="2"
                class="text-center line-h20"
              >
                <van-checkbox v-model="item2.checked">
                  <!-- <template #icon="props">
                    <img
                      class="img-icon"
                      :src="props.checked ? activeIcon : inactiveIcon"
                    />
                  </template> -->
                </van-checkbox>
              </van-col>
              <van-col
                span="4"
                class="text-center line-h20"
              >{{item2.real_name}}</van-col>
              <van-col
                span="2"
                class="text-center line-h20"
              >{{item2.sex=='man'?'男':'女'}}</van-col>
              <van-col
                span="3"
                class="text-center"
              >
                {{item2.room}}
              </van-col>

              <van-col
                :span="6"
                class="text-center line-h20"
                style="color:#ee0a24;"
              >{{item2.mobile_no}}</van-col>
              <van-col
                :span="6"
                class="text-center"
              >{{item2.business_name}}</van-col>
            </van-row>
          </div>
        </div>
      </div>
    </div>

    <van-popup
      v-model="showCities"
      position="bottom"
      :closeable="true"
      style="height:92vh"
    >
      <div style="width: 92%;height: 95%;margin-left: 15px;margin-top: 15px;">

        <!-- 标题 -->
        <div style="text-align: center;font-size: 20px;font-weight: 500;">
          选择目标小队
        </div>
        <!-- /标题 -->

        <div class="roll">
          <!-- 可选小队 -->
          <div
            v-for="(tItem,tIndex) in targetList"
            :key="tIndex"
          >
            <van-cell-group>
              <van-cell
                :title="tItem.team2.name"
                style="font-size: 18px;font-weight: 700;"
              />
            </van-cell-group>
            <div class="town">
              <div
                v-for="(item2,index2) in tItem.team3_list"
                :key="index2"
                style="display: inline-block;margin-top: 10px;"
                @click="onConfirm(item2)"
              >
                <van-tag
                  style="font-size: 14px;border-radius: 10px;"
                  :color="target===item2.name?'#FF9900':'#ffffff'"
                  :text-color="target===item2.name?'#ffffff':'#999999'"
                >{{item2.name}}</van-tag>

              </div>
            </div>

          </div>
          <!-- /可选小队-->

        </div>

        <div style="display:flex;justify-content: space-between;">
          <button
            class="buttons"
            style="background-color: #ee0a24;width: 100%;"
            @click="onSubmit()"
          >确定</button>
        </div>

      </div>
    </van-popup>

  </div>
</template>
<script>
export default {
  data() {
    return {
      List: [],
      team2_id: '',
      info: {},
      project_id: '', //营期id
      job: '',
      activeIcon: 'https://img01.yzcdn.cn/vant/user-active.png',
      inactiveIcon: 'https://img01.yzcdn.cn/vant/user-inactive.png',
      showCities: false,
      targetList: [],
      checkedList: [], //勾选的孩子
      target: '', //目标小队
      target_id: '', //目标小队id
    }
  },
  created() {
    this.job = this.$route.query.job
    this.project_id = this.$route.query.project_id
    this.team2_id = this.$route.query.team2_id
    this.getListInfo()
    this.getTarget()
  },

  methods: {
    async getListInfo() {
      const res = await this.$axios.get('project/teamlist3', {
        params: {
          team2_id: this.team2_id,
        },
      })
      if (res.data.code != 200) {
        this.$toast(res.data.msg)
        return
      }
      let data = res.data.data
      let teams_data = data.teams_data
      for (let i = 0; i < teams_data.length; i++) {
        for (let j = 0; j < teams_data[i].members.length; j++) {
          teams_data[i].members[j].checked = false
        }
      }
      this.List = teams_data
      this.info = data.team2_info
    },
    async getTarget() {
      const res = await this.$axios.get('/project/team-list', {
        params: {
          project_id: this.project_id,
        },
      })

      if (res.data.code != 200) {
        this.$toast(res.data.msg)
        return
      }
      this.targetList = res.data.data
      console.log(res.data.data)
    },
    onTarget() {
      let checkedList = []
      for (let i = 0; i < this.List.length; i++) {
        for (let j = 0; j < this.List[i].members.length; j++) {
          if (this.List[i].members[j].checked) {
            checkedList.push(this.List[i].members[j].id)
          }
        }
      }
      if (checkedList.length == 0) {
        this.$toast('请选择需要调整小队的孩子')
        return
      }

      this.checkedList = checkedList

      this.showCities = true
    },
    onConfirm(item) {
      this.target = item.name
      this.target_id = item.id
    },
    async onSubmit() {
      const res = await this.$axios.post('/project/team-switch', {
        ids: this.checkedList,
        team3_id: this.target_id,
      })
      setTimeout(() => {
        this.$toast(res.data.msg)

        // if (res.data.code == 200) {
          this.showCities = false
          this.target = ''
          this.target_id = []
          this.checkedList = null
          this.getListInfo()
        // }
      }, 500)
    },
  },
}
</script>
<style lang="scss" scoped>
.acmper {
  padding: 20px 20px;
  height: 100%;
}

.text-center {
  text-align: center;
  font-weight: 700;
  padding: 5px 0;
}

.line-h20 {
  line-height: 20px;
}
.buttons {
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
}
.roll {
  height: 500px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.town {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.town:after {
  content: '';
  width: 100px;
}
/deep/ .van-tag--default {
  width: 85px;
  font-size: 20px;
  padding: 5px;
  text-align: center !important;
  display: block;
  margin-bottom: 8px;
  border: 1px solid #999;
}
</style>